import React, { useEffect, useRef, useState } from "react";
import close from "../../assets/images/close.svg";
import { Col, Form, Row } from "react-bootstrap";
import StackedBarChart from "./StackedBarChart";
import { Link } from "react-router-dom";
import {
  commonservices,
  CurrentYear,
  MonthsArrayList,
} from "../../services/CommonServices";
import {
  getCostwidgetdata,
  getMonthlycostbydataby,
  getMonthlycostbydatabyWorkflowId,
} from "../../services/ReduxTookit/Slice/ReportRedux";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Loader, { LoaderType } from "./Loader";
import Nodata from "./Nodata";
import DatePicker from "react-datepicker";

function CostAndUsagePopup({ handleshowPopup, workflowid }) {
  const toUtcDayStartIso = (date) => {
    const value = new Date(date);
    if (Number.isNaN(value.getTime())) return "";

    return new Date(
      Date.UTC(
        value.getFullYear(),
        value.getMonth(),
        value.getDate(),
        0,
        0,
        0,
        0
      )
    ).toISOString();
  };

  const toUtcDayEndIso = (date) => {
    const value = new Date(date);
    if (Number.isNaN(value.getTime())) return "";

    return new Date(
      Date.UTC(
        value.getFullYear(),
        value.getMonth(),
        value.getDate(),
        23,
        59,
        59,
        999
      )
    ).toISOString();
  };

  let dispatch = useDispatch();
  const [ChartReportData, setChartReportData] = useState({
    labels: [],
    datasets: [],
  });

  let UserData = useSelector(
    (state) => state?.userredux?.GetByPrimarykeyData?.data?.data?.data
  );

  const [CostwidgetdataLoader, setCostwidgetdataLoader] = useState(false);
  const [CostwidgetList, setCostwidgetList] = useState([]);
  const currentMonth = new Date().getMonth();
  const [ChartReportHandle, setChartReportHandle] = useState({
    year: CurrentYear,
    month: currentMonth + 1,
  });
  const [ChartReportLoader, setChartReportLoader] = useState(false);
  let date = new Date();
  let defaultStartDate = moment(date).subtract(30, "days");
  const [startDate, setStartDate] = useState(new Date(defaultStartDate));
  const [endDate, setEndDate] = useState(date);
  let maxDateForRangePickerRef = useRef("");

  const handleDateChange = (dates) => {
    const [start, end] = dates;
    if (start) {
      maxDateForRangePickerRef.current = moment(start).add(30, "days");
    }
    if (end) {
      maxDateForRangePickerRef.current = "";
    }
    setStartDate(start);
    setEndDate(end);
  };

  async function fngetCostwidgetdata() {
    setCostwidgetdataLoader(true);
    let body = {
      currentmonthdate: new Date().toISOString(),
      workflowid: parseInt(workflowid),
    };
    dispatch(getCostwidgetdata(body))
      .then((response) => {
        if (response?.payload?.isValidate) {
          setCostwidgetdataLoader(false);
          setCostwidgetList(response?.payload?.data?.data);
        }
        if (!response?.payload?.isValidate) {
          setCostwidgetList([]);
        }
      })
      .finally(() => {
        setCostwidgetdataLoader(false);
      });
  }
  async function fngetChartReport(selectedyear, selectedmonth) {
    // if (selectedmonth) {
    //   selectedmonth = selectedmonth.toString().padStart(2, "0");
    // }
    setChartReportLoader(true);
    // let body = {
    //   databy: "machine",
    //   workflowid: parseInt(workflowid),
    //   date: `${selectedyear}-${selectedmonth}-01`,
    //   datagroupby: "date",
    // };
    let body = {
      startdate: startDate ? toUtcDayStartIso(startDate) : "",
      enddate: endDate ? toUtcDayEndIso(endDate) : "",
      workflowid: parseInt(workflowid),
    };
    try {
      //   const response = await dispatch(getMonthlycostbydataby(body));
      const response = await dispatch(getMonthlycostbydatabyWorkflowId(body));
      if (response?.payload?.isValidate) {
        setChartReportLoader(false);
        let templables = [];
        let tempdatasets = [];
        let dataByLabel = {};
        const data1 = response?.payload?.data?.data || [];
        data1.forEach((element) => {
          templables.push(element.monthandyear);
          if (!dataByLabel[element.displayname]) {
            dataByLabel[element.displayname] = [];
          }
          dataByLabel[element.displayname].push({
            monthandyear: element.monthandyear,
            bill: element.bill,
          });
        });
        templables = [...new Set(templables)];
        for (const [label, items] of Object.entries(dataByLabel)) {
          const dataset = {
            label: label,
            data: templables.map((month) => {
              const item = items.find((i) => i.monthandyear === month);
              return item ? item.bill : 0;
            }),
            backgroundColor: commonservices.CreateColor(label)?.BGColor,
          };
          tempdatasets.push(dataset);
        }

        setChartReportData({
          labels: templables,
          datasets: tempdatasets,
        });
      } else {
        setChartReportLoader(false);
        setChartReportData({
          labels: [],
          datasets: [],
        });
      }
    } catch (error) {
      setChartReportLoader(false);
    } finally {
      setChartReportLoader(false);
    }
  }
  useEffect(() => {
    fngetCostwidgetdata();
  }, []);

  //   useEffect(() => {
  //     fngetChartReport(ChartReportHandle?.year, ChartReportHandle?.month);
  //   }, [ChartReportHandle]);
  useEffect(() => {
    if (startDate && endDate) {
      fngetChartReport();
    }
  }, [startDate, endDate]);

  function fnDataTotal(data) {
    let total = 0;
    if (Array.isArray(data) && data.length > 0) {
      for (let item of data) {
        total += +item;
      }
    }
    return commonservices.fnAmountDigitCount(total, 5);
  }

  return (
    <div className="schedular-popup cost-and-usage-popup">
      <div className="popup-title">
        <div className="d-flex justify-content-between align-items-center">
          <h2 className="width125">Cost & Usage</h2>
          <div className="width210">
            <DatePicker
              monthsShown={2}
              onChange={handleDateChange}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              placeholderText="Select Date Range"
              isClearable
              dateFormat="MM/dd/yyyy"
              maxDate={
                maxDateForRangePickerRef.current
                  ? new Date(maxDateForRangePickerRef.current)
                  : ""
              }
            />
          </div>
        </div>

        <img
          src={close}
          alt="close"
          id="cost-usage"
          onClick={(e) => {
            handleshowPopup(e);
          }}
          className="cursor-pointer"
        />
      </div>
      <div className="popup-body">
        <Row>
          <Col xl={12}>
            <div className="dashboard-stacked-chart stacked-chart-in-popup">
              <div className="d-flex justify-content-between align-items-center gap-3">
                <h5>Billing</h5>
                {/* <div className="d-flex justify-content-between align-items-center gap-3">
                  <Form.Select
                    onChange={(e) => {
                      setChartReportHandle({
                        ...ChartReportHandle,
                        ["month"]: parseInt(e.target.value),
                      });
                    }}
                    aria-label="Default select example"
                  >
                    {MonthsArrayList?.map((item, index) => (
                      <option key={index} value={item?.number}>
                        {item?.short}
                      </option>
                    ))}
                  </Form.Select>
                  <Form.Select
                    onChange={(e) =>
                      setChartReportHandle({
                        ...ChartReportHandle,
                        ["year"]: parseInt(e.target.value),
                      })
                    }
                    aria-label="Default select example"
                  >
                    {commonservices.fnLastYearList(5).map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </Form.Select>
                </div> */}
              </div>
              {ChartReportLoader ? (
                <div className="my-2">
                  <Loader type={LoaderType.ChartThinLine} />
                </div>
              ) : (
                <>
                  {ChartReportData?.datasets?.length > 0 ? (
                    <div className="dashboard-stacked-chart-main-chart-wrapper">
                      <StackedBarChart
                        barthickness="10"
                        data={ChartReportData}
                      />
                    </div>
                  ) : (
                    <Nodata />
                  )}
                </>
              )}
            </div>
          </Col>
          <Col xl={6}>
            <div className="costing-sec  costwarning mt12">
              {CostwidgetdataLoader ? (
                <Loader type={LoaderType.CostWidget} count={4} />
              ) : (
                <>
                  <div className="all-costing-box">
                    <div className="single-costing-box common-white-bg">
                      <h5>
                        $
                        {CostwidgetList?.[0]?.monthtodate
                          ? commonservices.fnAmountDigitCount(
                            CostwidgetList?.[0]?.monthtodate,
                            3
                          )
                          : 0}
                      </h5>
                      <p>
                        Current <br />
                        Month
                      </p>
                    </div>
                    <div className="single-costing-box common-white-bg">
                      <h5>
                        $
                        {CostwidgetList?.[0]?.lastmonth
                          ? commonservices.fnAmountDigitCount(
                            CostwidgetList?.[0]?.lastmonth,
                            3
                          )
                          : 0}
                      </h5>
                      <p>
                        Last <br /> Month
                      </p>
                    </div>
                    <div className="single-costing-box common-white-bg">
                      <h5>
                        $
                        {CostwidgetList?.[0]?.avgofmonth
                          ? commonservices.fnAmountDigitCount(
                            CostwidgetList?.[0]?.avgofmonth,
                            3
                          )
                          : 0}
                      </h5>
                      <p>
                        Average
                        <br /> Month
                      </p>
                    </div>
                    <div className="single-costing-box common-white-bg">
                      <h5>
                        $
                        {CostwidgetList?.[0]?.forcasteofmonth
                          ? commonservices.fnAmountDigitCount(
                            CostwidgetList?.[0]?.forcasteofmonth,
                            3
                          )
                          : 0}
                      </h5>
                      <p>
                        Forecast
                        <br /> of Month
                      </p>
                    </div>
                  </div>
                  <div
                    className={
                      CostwidgetList?.[0]?.lastmonthchange <= 0
                        ? "green-warning-sec"
                        : "red-warning-sec"
                    }
                  >
                    <p>
                      <span>
                        <b>
                          {Math.abs(CostwidgetList?.[0]?.lastmonthchange) > 0
                            ? Math.abs(CostwidgetList?.[0]?.lastmonthchange)
                            : 0}
                          %
                        </b>
                      </span>{" "}
                      {CostwidgetList?.[0]?.lastmonthchange <= 0
                        ? "Down"
                        : "Up"}{" "}
                      from last month
                    </p>
                  </div>
                </>
              )}
            </div>
          </Col>
          {/* <Col xl={6}>
            <div className="stacked-chart-in-popup machinebilldata mt12">
              <div className="chart-title">
                <h5>Machine Billing</h5>
              </div>
              {ChartReportLoader ? (
                <Loader type={LoaderType.Line} count={4} />
              ) : (
                <div className="component-billing-wrapper">
                  {ChartReportData?.datasets?.length > 0 ? (
                    <>
                      {ChartReportData?.datasets
                        ?.filter((item) => item?.label === "Starter")
                        ?.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="single-component-billing"
                            >
                              <div className="d-flex align-item-center gap-1">
                                <div
                                  className="single-component-sm-box"
                                  style={{
                                    background: commonservices.CreateColor(
                                      item?.label
                                    )?.BGColor,
                                  }}
                                ></div>
                                <p>{item?.label}</p>
                              </div>
                              <div>
                                <h4>${fnDataTotal(item?.data)}</h4>
                              </div>
                            </div>
                          );
                        })}
                      {ChartReportData?.datasets
                        ?.filter(
                          (item) =>
                            item?.label !== "Starter" && item?.label !== "Exit"
                        )
                        ?.map((item, index) => (
                          <div key={index} className="single-component-billing">
                            <div className="d-flex align-item-center gap-1">
                              <div
                                className="single-component-sm-box"
                                style={{
                                  background: commonservices.CreateColor(
                                    item?.label
                                  )?.BGColor,
                                }}
                              ></div>
                              <p>{item?.label}</p>
                            </div>
                            <div>
                              <h4>${fnDataTotal(item?.data)}</h4>
                            </div>
                          </div>
                        ))}
                      {ChartReportData?.datasets
                        ?.filter((item) => item?.label === "Exit")
                        ?.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="single-component-billing"
                            >
                              <div className="d-flex align-item-center gap-1">
                                <div
                                  className="single-component-sm-box"
                                  style={{
                                    background: commonservices.CreateColor(
                                      item?.label
                                    )?.BGColor,
                                  }}
                                ></div>
                                <p>{item?.label}</p>
                              </div>
                              <div>
                                <h4>${fnDataTotal(item?.data)}</h4>
                              </div>
                            </div>
                          );
                        })}
                    </>
                  ) : (
                    <Nodata />
                  )}
                </div>
              )}
            </div>
          </Col> */}
          <Col xl={6}>
            <div className="stacked-chart-in-popup machinebilldata mt12">
              <div className="chart-title">
                <h5>Machine Billing</h5>
              </div>
              {ChartReportLoader ? (
                <Loader type={LoaderType.Line} count={4} />
              ) : (
                <div className="component-billing-wrapper">
                  {ChartReportData?.datasets?.length > 0 ? (
                    ["Starter", "Other", "Exit"].map((category) =>
                      ChartReportData?.datasets
                        .filter((item) =>
                          category === "Other"
                            ? item?.label?.toUpperCase() !== "STARTER" &&
                            item?.label?.toUpperCase() !== "EXIT"
                            : item?.label === category
                        )
                        .map((item, index) => (
                          <div key={index} className="single-component-billing">
                            <div className="d-flex align-item-center gap-1">
                              <div
                                className="single-component-sm-box"
                                style={{
                                  background: commonservices.CreateColor(
                                    item?.label
                                  )?.BGColor,
                                }}
                              ></div>
                              <p>{item?.label}</p>
                            </div>
                            <div>
                              <h4>${fnDataTotal(item?.data)}</h4>
                            </div>
                          </div>
                        ))
                    )
                  ) : (
                    <Nodata />
                  )}
                </div>
              )}
            </div>
          </Col>
        </Row>
      </div>
      {UserData?.associationtype !== "Contacts" && (
        <div className="popup-footer">
          <Link
            onClick={() => {
              document.getElementById("body").classList.remove("popup-is-open");
            }}
            to="/billing-and-cost-maangement"
            className="theme-color-text fw600"
          >
            Go to Billing & Cost Management
          </Link>
        </div>
      )}
    </div>
  );
}

export default CostAndUsagePopup;
